import React from 'react';
export function TestimonialsRow() {
  const testimonials = [{
    initials: 'LG',
    color: 'bg-blue-500',
    quote: 'Llegué a tercer año con apuntes de 5 compañeros distintos que no coincidían entre sí. Con el Nivel 1 tuve por primera vez un sistema claro para entender qué estudiar y en qué orden. Aprobé Anatomía con 8.',
    author: 'Lucas G., Córdoba',
    info: '3° año Medicina UNC'
  }, {
    initials: 'SV',
    color: 'bg-purple-500',
    quote: 'Siempre llegaba a los parciales sin saber si había estudiado lo correcto. Con el Nivel 2 eso cambió: tengo el sistema de estudio armado, sé cómo organizarme y cómo repasar. Ya aprobé Farmacología y Fisiología con él.',
    author: 'Sofía V., Buenos Aires',
    info: '4° año Medicina UBA'
  }, {
    initials: 'MP',
    color: 'bg-emerald-500',
    quote: 'Me tomé el Nivel 3 con los editables y fue un cambio total. Tengo todo organizado por tomos, llegué a los finales mucho más tranquila y preparada que nunca.',
    author: 'Martina P., Rosario',
    info: '3° año Medicina UNR'
  }];
  return <section className="w-full bg-slate-50 py-12 md:py-20 px-4" data-id="element-422">
      <div className="max-w-6xl mx-auto" data-id="element-423">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-424">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 flex flex-col h-full" data-id="element-425">
              <div className="flex items-center gap-4 mb-4" data-id="element-426">
                <div className={`w-12 h-12 rounded-full ${t.color} text-white flex items-center justify-center font-bold text-lg shrink-0`} data-id="element-427">
                  {t.initials}
                </div>
                <div className="flex text-brand-amber text-lg" data-id="element-428">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-slate-700 italic mb-6 flex-grow" data-id="element-429">
                "{t.quote}"
              </p>
              <div className="mt-auto pt-4 border-t border-slate-100" data-id="element-430">
                <div className="font-bold text-slate-900" data-id="element-431">{t.author}</div>
                <div className="text-sm text-slate-500" data-id="element-432">{t.info}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}